// Enum of possible action types
export enum PreviousStepReducerActionTypes {
  PREVIOUS_STEP_UPDATE = 'PREVIOUS_STEP_UPDATE',
}

export interface PreviousStepReducerAction {
  type: PreviousStepReducerActionTypes;
  payload: number;
}

export type PreviousStepReducerState = number | null;

export const previousStepReducerInitialState: PreviousStepReducerState = null;

const previousStepReducer = (
  state: PreviousStepReducerState,
  action: PreviousStepReducerAction
): PreviousStepReducerState => {
  switch (action.type) {
    case PreviousStepReducerActionTypes.PREVIOUS_STEP_UPDATE: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

export default previousStepReducer;
